
import Can from "../../common/Can";
import { Navigate } from "react-router";
import { usePermissionContext } from "../../../contexts/ProviderProvider";
import AssetUploader from "./AssetUploader";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AssetTable from "./AssetTable";

export const Component = () => {
    const { views } = usePermissionContext();

    console.log(`views`, views);
    return (
        <>
            <Can
                action={views.VIEW}
                items={[views.ASSETUPLOADER]}
                els={<Navigate to="/ballpark" />}
            >
                <AssetUploader />
            </Can>
            <Can
                action={views.VIEW}
                items={[views.ASSETVIEWER]}
                els={<Navigate to="/ballpark" />}
            >
                <AssetTable />
            </Can>
        </>
    );
};
export const icon = <CloudUploadIcon />;
export const text = "Asset Uploader";
export const componentName = "Asset Uploader";
export const path = "assetUploader";
